<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="form">
                    <v-container py-0>
                        <v-layout wrap>    
                            <v-flex xs12 md12>
                                <date-picker :readonly="permiteAlteracaoDataContratacaoReal" :label="txtDataAdmissaoReal" v-model="dataAdmissaoReal"></date-picker>                                                                                                                                                             
                            </v-flex>                                                                                  

                            <v-flex xs12 md12>
                                <v-text-field :readonly="true" :label="txtLogin" v-model="login"
                                    :rules="rules.login"></v-text-field>                                                                               
                            </v-flex>   

                            <v-flex xs12 md12>
                                <v-text-field :readonly="true" :label="txtEmail" v-model="email" :suffix="exibirDominio"
                                    :rules="rules.email"></v-text-field>                                                                                                             
                            </v-flex>  

                            <v-flex xs12 md12>
                                <v-flex xs12 md12>
                                    <v-row class="optNecessitaEmail">{{optNecessitaEmail}}</v-row>
                                    <v-row>
                                        <v-radio-group :readonly="value.indicadorAprovado == true && value.dataGeracaoEmail != null" v-model="necessitaEmail" row>
                                            <v-radio :label="yes" :value="true"></v-radio>
                                            <v-radio :label="no" :value="false"></v-radio>
                                        </v-radio-group>                    
                                    </v-row>                
                                </v-flex>
                            </v-flex>   

                            <v-flex xs12 md12 v-if="(value.indicadorAprovado == false || value.indicadorAprovado == null) || (value.indicadorAprovado == true && value.dataGeracaoEmail == null)" >
                                <v-btn class="success" @click="btnSugerirLogin_OnClick">
                                    <v-icon left>mdi-account-badge-horizontal</v-icon> 
                                    {{sugerirLogin}}
                                </v-btn>                                                                                     

                                <v-btn v-show="necessitaEmail" @click="btnEmailPersonalizado_OnClick">
                                    <v-icon left>mdi-at</v-icon> 
                                    E-mail personalizado
                                </v-btn>                                                                                                 
                            </v-flex>
                        </v-layout>
                    </v-container>         
                </v-form>                  
            </v-flex>            
        </v-layout>     

        <form-dialog v-model="exibirSugestao" maxWidth="600px" :title="tituloPreCadastro"
            :confirm_OnClick="btnConfirmarSugestao_OnClick">

            <v-container fluid>
                <template v-if="value.indicadorAprovado == false || value.indicadorAprovado == null">
                    <h4>{{txtLogin}}</h4><hr>
                    <v-radio-group v-model="loginSelecionado" :rules="rules.login">
                        <v-radio :readonly="value.indicadorAprovado == true"  v-for="(l, index) in listaLogin" :label="l" :value="l" :key="`login-${index}`"></v-radio>
                    </v-radio-group>                    
                </template>

                <template v-if="necessitaEmail">
                    <h4>{{txtEmail}}</h4><hr >
                    <v-radio-group v-model="emailSelecionado" :rules="rules.email">
                        <v-radio v-for="(e, index) in listaEmail" :label="`${e}${exibirDominioLista}`" :value="e" :key="`email-${index}`"></v-radio>
                    </v-radio-group>     
                    
                    <v-select :label="cboDominio" :items="listaDominioEmailPais" return-object v-model="dominioEmail"
                        item-value="id" item-text="descricao" :no-data-text="cboDominioSemDados"></v-select>                    
                </template>
            </v-container>
        </form-dialog>     

        <form-dialog v-model="exibirSugestaoEmailCustomizada" maxWidth="600px" :title="tituloPreCadastro"
            :confirm_OnClick="btnConfirmarEmailPersonalizado_OnClick">

            <v-container fluid>
                <v-flex xs12 md12>
                    <v-text-field :rules="rules.email" :suffix="exibirDominioLista" :label="txtEmail" v-model="emailSelecionado" 
                        :required="true" :requiredText="preenchaEmailPersonalizado" @blur="txtEmail_OnBlur" ></v-text-field>                                                                               
                </v-flex>     

                <v-flex xs12 md12>
                    <v-select :label="cboDominio" :items="listaDominioEmailPais" return-object v-model="dominioEmail"
                        item-value="id" item-text="descricao" :no-data-text="cboDominioSemDados"></v-select>
                </v-flex>            

                <v-flex xs12 md12>
                    <v-textarea :rules="rules.justificativaEmailPersonalizado" 
                        :label="justificativa" v-model="justificativaEmailPersonalizado"></v-textarea>                                                                           
                </v-flex>                               
            </v-container>
        </form-dialog>                 
    </v-container>
</template>

<script>
import StringMixin from '@/mixin/string'
import FormMixin from '@/mixin/form'
import StepMixin from './mixin'

import OnboardingConstantes from '@/constants/onboarding/parametrizacao'
import PaisConstantes from '@/constants/corporativo/pais'
import ParametrizacaoUtil from '../../utils/parametrizacao'

import DateMixin from '@/mixin/date'
import DatePicker from '@/components/material/DatePicker'
import FormDialog from '@/components/material/FormDialog'

import PreCadastroApi from '@/api/workspace/onboarding/precadastro'
import DominioEmailApi from '@/api/workspace/onboarding/dominioemail'

export default {
    mixins: [ FormMixin, StepMixin, DateMixin, StringMixin ],  
    components: {
        "date-picker": DatePicker,
        "form-dialog": FormDialog
    },    
    watch: {
        async value(newValue, oldValue){     
            if(newValue.indicadorAprovado == true)
                this.sugerirApenasUmaVez = true;                 

            else if((newValue.primeiroNomeAlterado || "") != (oldValue.primeiroNomeAlterado || ""))
                this.sugerirApenasUmaVez = false;
            
            else if((newValue.ultimoNomeAlterado || "") != (oldValue.ultimoNomeAlterado || ""))
                this.sugerirApenasUmaVez = false;         

            else if(newValue != null && (newValue.atributo || []).length > 0){
                this.sugerirCredenciais(newValue);
            }             
        },
    },
    data () {
        return { 
            exibirSugestao: false,
            exibirSugestaoEmailCustomizada: false,
            listaLogin: [],
            listaEmail: [],
            listaDominioEmail: [ ],
            dominioEmail: null,
            loginSelecionado: null,
            emailSelecionado: null,
            sugerirApenasUmaVez: false,
            justificativaEmailPersonalizado: null,
            sugerirCredenciais: null,
            rules:{
                login: [
                    val => {
                        if(this.$_.trim(val) == "")
                            return this.$t('Views.Onboarding.Colaborador.PreCadastro.login-obrigatorio');                                

                        return true;
                    }
                ],
                email: [
                    val => {
                        if(this.necessitaEmail && this.$_.trim(val) == "")
                            return this.$t('Views.Onboarding.Colaborador.PreCadastro.email-obrigatorio');  
                            
                        if(this.dominioEmail != null && !this.validateEmail(`${val}@${this.dominioEmail.descricao}`))
                            return this.$t('Views.Onboarding.Colaborador.PreCadastro.email-invalido');  

                        return true;
                    }
                ],  
                justificativaEmailPersonalizado: [
                    val => {
                        if(this.$_.trim(val) == "")
                            return this.$t('Views.Onboarding.Colaborador.PreCadastro.justificativa-email-obrigatoria');                                

                        return true;
                    }
                ],                                
            }
        }
    },
    computed: {  
        sugerirLogin () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.sugerir-login');
        },
        optNecessitaEmail(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.necessita-email');            
        },  
        txtDataAdmissaoPrevista(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.data-admissao-prevista');            
        },      
        dataAdmissaoPrevista:{
            get(){
                if(this.value != null && this.value != undefined){
                    if(this.value.dataAdmissaoPrevista == null)
                        return null;

                    return this.$moment(this.value.dataAdmissaoPrevista).toDate();
                }

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                                 
                    if(value != null){
                        onboarding.dataAdmissaoPrevista = value; 
                    }
                    else{
                        onboarding.dataAdmissaoPrevista = null;           
                    }
                    
                    this.$emit("input", onboarding);
                }              
            }
        },               
        txtDataAdmissaoReal(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.data-admissao-real');            
        },        
        dataAdmissaoReal:{
            get(){
                if(this.value != null && this.value != undefined){
                    if(this.value.dataAdmissaoReal == null)
                        return null;

                    let momentUtc = this.$moment.utc(this.value.dataAdmissaoReal);
                    let year = this.$_.parseInt(momentUtc.format("YYYY"));

                    let month = this.$_.parseInt(momentUtc.format("MM")) - 1;
                    let day = this.$_.parseInt(momentUtc.format("DD"));      

                    return new Date(year, month, day);
                }

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);

                    onboarding.dataAdmissaoReal = (value != null) ? this.$moment(value).format("YYYY-MM-DDT00:00:00") + "Z" : null; 
                    onboarding.permiteAlteracao = true;
                    this.$emit("input", onboarding);
                }              
            }
        },
        permiteAlteracaoDataContratacaoReal(){
            let permiteAlteracao = false;

            if(this.value.indicadorAprovado)
                return true;

            if(this.value.permiteAlteracao != undefined)
                permiteAlteracao = this.value.permiteAlteracao;

            if(this.value.dataAdmissaoReal != null && !permiteAlteracao)
                return true;
            
            return false;
        },
        txtLogin(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.login-sugerido');            
        },     
        login:{
            get(){
                if(this.value != null && this.value != undefined)
                    return this.value.login;

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.login = (value != null) ? value : null; 
                    this.$emit("input", onboarding);
                }              
            }
        },                 
        txtEmail(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.email-sugerido');            
        },
        email:{
            get(){
                if(this.value != null && this.value != undefined)
                    return this.value.email;

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.email = (value != null) ? value : null; 
                    this.$emit("input", onboarding);
                }              
            }
        },            
        aprovarFinalizar(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.aprovar-finalizar');            
        },
        tituloPreCadastro(){
            if(this.necessitaEmail)
                return this.$t('Views.Onboarding.Colaborador.PreCadastro.titulo-sugestao-login-email');            
            else
                return this.$t('Views.Onboarding.Colaborador.PreCadastro.titulo-sugestao-login');            
        },
        tituloSemSugestao(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.sem-sugestao-titulo');            
        },      
        descricaoSemSugestao(){
            if(this.exibirPreCadastro)
                return this.$t('Views.Onboarding.Colaborador.PreCadastro.sem-gestao-descricao-login-email');            

            else
                return this.$t('Views.Onboarding.Colaborador.PreCadastro.sem-gestao-descricao-login');            
        },
        exibirDominio(){
            if(this.value == null || this.value == undefined)
                return null;

            if(this.value.dominioEmail == null || this.value.dominioEmail == undefined)
                return null;

            return `@${this.value.dominioEmail.descricao}`
        },
        exibirDominioLista(){
            if(this.dominioEmail == null || this.dominioEmail == undefined)
                return "";

            return `@${this.dominioEmail.descricao}`
        },
        preenchaEmailPersonalizado(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.sem-sugestao-titulo');            
        },
        listaDominioEmailPais(){
            if(this.value != null && this.value.pais != null)
                return this.listaDominioEmail.filter(de => de.pais.id == this.value.pais.id);

            return [];
        },
        necessitaEmail:{
            get(){
                return this.value.dominioEmail != null;           
            },
            set(value){
                let onboarding = this.$_.clone(this.value);
                this.dominioEmail = null;

                if(!value){         
                    onboarding.dominioEmail = null; 
                    onboarding.email = null;      

                    onboarding.justificativaCustomizacaoEmail = null;      
                    this.emailSelecionado = null;    
                }
                else{
                    if(this.value.dominioEmail != null){
                        this.dominioEmail = this.listaDominioEmail.filter(de => de.id == this.value.dominioEmail.id)[0];                        
                    }
                    else{
                        this.dominioEmail = this.listaDominioEmail.filter(de => de.pais.id == this.value.pais.id && de.descricao == "sonda.com")[0];
                    }         
                    
                    onboarding.dominioEmail = this.dominioEmail; 
                }

                this.$emit("input", onboarding);  
            }
        },
        cboDominio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.dominio');            
        },  
        cboDominioSemDados(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.dominio-sem-dados');            
        },          
        justificativa(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.justificativa');            
        }
    },
    async created(){
        this.setLoaderQueue(this.uniqueId); 
        await this.listarDominioEmail();

        if(this.value != null && this.value.pais != null){
            let dominioEmail = this.listaDominioEmail.filter(de => de.pais.id == this.value.pais.id && de.descricao == "sonda.com");

            if((dominioEmail || []).length > 0)
                this.$set(this, "dominioEmail", dominioEmail[0]);
            else 
                this.$set(this, "dominioEmail", null);
        }
        
        this.unsetLoaderQueue(this.uniqueId);    
        this.sugerirCredenciais = this.$_.debounce(
            async (colaborador) => {
                this.setLoaderQueue(this.uniqueId);        

                if(this.value.dominioEmail == null){
                    this.emailSelecionado = null;
                    this.justificativaEmailPersonalizado = null;
                }   

                let atributo =  this.getValorAtributo(OnboardingConstantes.dadosColaborador.PRIMEIRO_NOME);
                let primeiroNome = atributo == null ? null : atributo.valor;                               

                atributo = this.getValorAtributo(OnboardingConstantes.dadosColaborador.ULTIMO_NOME);
                let ultimoNome = atributo == null ? null : atributo.valor;
                
                if(!this.sugerirApenasUmaVez && colaborador.pais != null && this.$_.trim(primeiroNome) != "" && this.$_.trim(ultimoNome) != ""){
                    this.sugerirApenasUmaVez = true;

                    this.dominioEmail = this.listaDominioEmail.filter(de => de.pais.id == this.value.pais.id && de.descricao == "sonda.com")[0];
                    colaborador.dominioEmail = this.dominioEmail;                     

                    const sugestao = await this.listarSugestoes(colaborador);
                    if(sugestao != null){
                        let onboarding = this.$_.clone(colaborador);
                        if(sugestao.login != null && sugestao.login.length > 0) {
                            this.listaLogin = sugestao.login;                          
                            this.loginSelecionado = onboarding.login = sugestao.login[0];
                        }

                        if(sugestao.email != null && sugestao.email.length > 0) {
                            const dominioEmail = this.listaDominioEmail.filter(de => de.pais.id == this.value.pais.id && de.descricao == "sonda.com");

                            this.emailSelecionado = onboarding.email = sugestao.email[0];
                            this.dominioEmail = onboarding.dominioEmail = dominioEmail[0];
                        }

                        this.$emit("input", onboarding);                            
                    } 
                } 
                
                this.unsetLoaderQueue(this.uniqueId); 
            },
            1000
        );
    },
    beforeDestroy(){
        this.sugerirCredenciais.cancel();
    },   
    methods:{     
        txtEmail_OnBlur(){
            if(this.emailSelecionado != null && this.emailSelecionado != undefined){
                this.emailSelecionado = this.emailSelecionado.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            }
        },
        btnConfirmarSugestao_OnClick(){
                let onboarding = this.$_.clone(this.value);
                onboarding.email = this.emailSelecionado;

                onboarding.dominioEmail = this.dominioEmail;
                if(this.value.indicadorAprovado == null || this.value.indicadorAprovado == false)
                    onboarding.login = this.loginSelecionado;

                this.$emit("input", onboarding);
                this.exibirSugestao = false;
        },
        btnEmailPersonalizado_OnClick(){
            this.exibirSugestaoEmailCustomizada = true;
        },
        btnConfirmarEmailPersonalizado_OnClick(){
            let onboarding = this.$_.clone(this.value);
            onboarding.email = this.emailSelecionado;

            onboarding.dominioEmail = this.dominioEmail;
            onboarding.justificativaCustomizacaoEmail = this.justificativaEmailPersonalizado;

            this.$emit("input", onboarding);
            this.exibirPreCadastro = false;
        },
        async btnSugerirLogin_OnClick(){
            if(this.value != null){
                const loading = this.showLoading();

                let atributo = this.getValorAtributo(OnboardingConstantes.dadosColaborador.PRIMEIRO_NOME);
                let primeiroNome = atributo == null ? null : atributo.valor;                           

                atributo = this.getValorAtributo(OnboardingConstantes.dadosColaborador.ULTIMO_NOME);
                let ultimoNome = atributo == null ? null : atributo.valor;                          

                if(this.value.pais == null){
                    this.showPendency(this.$t("Views.Onboarding.Colaborador.PreCadastro.pais-nao-preenchido-sugestao"));
                }
                else if(primeiroNome == null || this.$_.trim(primeiroNome) == ""){
                    this.showPendency(this.$t("Views.Onboarding.Colaborador.PreCadastro.primeiro-nome-nao-preenchido-sugestao"));
                }
                else if(ultimoNome == null || this.$_.trim(ultimoNome) == ""){
                    this.showPendency(this.$t("Views.Onboarding.Colaborador.PreCadastro.ultimo-nome-nao-preenchido-sugestao"));
                }       
                else{
                    let sugestao = await this.listarSugestoes(this.value);
                    if(sugestao == null || (sugestao.login.length == 0 && sugestao.email.length == 0)){
                        this.showMessage(
                            this.tituloSemSugestao,
                            this.descricaoSemSugestao,
                            null
                        );
                    }
                    else{
                        if(this.necessitaEmail){
                            let onboarding = this.$_.clone(this.value);
                            onboarding.justificativaCustomizacaoEmail = null;                            

                            this.$emit("input", onboarding);
                            this.justificativaEmailPersonalizado = null;
                        }
                            
                        if(sugestao.login.length > 0) 
                            this.listaLogin = sugestao.login;                          

                        if(sugestao.email.length > 0) 
                            this.listaEmail = sugestao.email;   
                            
                        this.exibirSugestao = true;
                    }
                } 
                
                loading.close();
            }
            else{
                this.showPendency(this.$t("Views.Onboarding.Colaborador.PreCadastro.dados-colaborador-nao-preenchido"));
            }
        },
        async listarSugestoes(onboarding){
            const self = this;
            if(onboarding != null){
                let atributo = self.getValorAtributo(OnboardingConstantes.dadosColaborador.PRIMEIRO_NOME);
                let primeiroNome = atributo == null ? null : atributo.valor;                                      

                atributo = self.getValorAtributo(OnboardingConstantes.dadosColaborador.ULTIMO_NOME);
                let ultimoNome = atributo == null ? null : atributo.valor;                          

                if(self.value.pais == null ){
                    return null;
                }
                else if(primeiroNome == null || self.$_.trim(primeiroNome) == ""){
                    return null;
                }
                else if(ultimoNome == null || self.$_.trim(ultimoNome) == ""){
                    return null;
                }       
                else{
                    let resultado = {
                        login: [], 
                        email: []
                    };    

                    self.listaLogin = [];
                    if(onboarding.indicadorAprovado == null || onboarding.indicadorAprovado == false){
                        let login =  null;
                        if(onboarding.pais.codigoDuasLetrasSuccessFactors == PaisConstantes.brasil.codigoDuasLetras){
                            login = await PreCadastroApi.sugerirEmail(
                                onboarding.id, 
                                primeiroNome,
                                ultimoNome
                            ).catch(erro => self.showSnackbarError(erro.error));
                        }
                        else{
                            login = await PreCadastroApi.sugerirLogin(
                                onboarding.id, 
                                primeiroNome,
                                ultimoNome
                            ).catch(erro => self.showSnackbarError(erro.error));                            
                        }
                        
                        if(login.success && login.data.length > 0){
                            resultado.login = login.data;
                        } 
                    }

                    if(self.necessitaEmail){
                        const email = await PreCadastroApi.sugerirEmail(
                            onboarding.id, 
                            primeiroNome,
                            ultimoNome
                        ).catch(erro => self.showSnackbarError(erro.error));              

                        self.listaEmail = [];
                        if(email.success && email.data.length > 0){
                            resultado.email = email.data;                        
                        } 
                    }
                
                    return resultado
                }
            }

            return null;
        },
        async listarDominioEmail(){
            const dominioEmail = await DominioEmailApi.listar().catch(erro => this.showSnackbarError(erro.error));
            this.listaDominioEmail = (dominioEmail.success && dominioEmail.data.length > 0) ? dominioEmail.data : [];
        },        
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";
.optNecessitaEmail{
    color: $brand-primary;
}
</style>
